const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-addon" */ '@/pages/financial/tariff/furniture/addon/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-addon" */ '@/pages/financial/tariff/furniture/addon/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-addon" */ '@/pages/financial/tariff/furniture/addon/edit.vue'
  )

export default {
  name: 'FinancialFurnitureAddonTariff',
  path: 'addon',
  meta: {
    label: 'addon',
    auth: 'addon'
  },
  component: {
    name: 'Addon',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffAddonReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffAddon',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffAddon',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
